// @ts-nocheck
import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { registerLicense } from "@syncfusion/ej2-base";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import "./i18n/i18n";
import { scrubEvent, scrubBreadcrumb } from "includes/sentryScrub";
import ServerCheck from "ServerCheck";
import MarkerIoButton from "components/MarkerIoButton/MarkerIoButton";
import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";

// Unregister stale service workers in development — they intercept API requests
if (import.meta.env.MODE === "development" && "serviceWorker" in navigator) {
	navigator.serviceWorker.getRegistrations().then((registrations) => {
		registrations.forEach((r) => {
			r.unregister();
			console.log("[DEV] Unregistered service worker:", r.scope);
		});
	});
}

// Warn about missing critical env vars at boot (silent in dev, visible in prod builds)
if (import.meta.env.MODE !== "development") {
	const required = {
		VITE_STORAGE_SECRET_KEY: import.meta.env.VITE_STORAGE_SECRET_KEY,
		VITE_SYNCFUSION_LICENSE_KEY: import.meta.env.VITE_SYNCFUSION_LICENSE_KEY,
	};
	const missing = Object.entries(required)
		.filter(([, v]) => !v)
		.map(([k]) => k);
	if (missing.length > 0) {
		console.error(
			`[OnlyAll] Missing critical env vars: ${missing.join(", ")}. ` +
			"Check GitHub Actions secrets and workflow config."
		);
	}
}

//syncfusion licence
if (import.meta.env.VITE_SYNCFUSION_LICENSE_KEY) {
	registerLicense(import.meta.env.VITE_SYNCFUSION_LICENSE_KEY);
}

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
		},
	},
});

if (import.meta.env.MODE !== "development" && import.meta.env.VITE_SENTRY_DSN) {
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		integrations: [new BrowserTracing()],
		environment: import.meta.env.VITE_ENVIRONMENT || "unknown",
		tracesSampleRate: 0.3,
		// reset links carry ?token=...: keep it out of events and breadcrumbs
		beforeSend: scrubEvent,
		beforeBreadcrumb: scrubBreadcrumb,
	});
}

const root = createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<ErrorBoundary>
			<QueryClientProvider client={queryClient}>
				<ServerCheck>
					<App />
				</ServerCheck>
				<MarkerIoButton />
			</QueryClientProvider>
		</ErrorBoundary>
	</React.StrictMode>
);
